






import { Component, Prop, Vue } from 'vue-property-decorator';
import { LinkDto } from '@/api';
import Routes from '@/util/Routes';

@Component
export default class CmsLink extends Vue {
  @Prop({required: true})
  public readonly model!: LinkDto;

  @Prop({required: false, default: false})
  public readonly omitIfNoCaption!: boolean;

  get linkTarget(): string | undefined {
    if (this.model.target === '') {
      return undefined;
    } else {
      return this.model.target ?? undefined;
    }
  }

  get htmlTarget(): string {
    return this.model.newTab ? '_blank' : '_self';
  }

  public handleClick(event: MouseEvent): void {
    if (this.model.target?.startsWith('/page/') && !this.model.newTab) { // prevent unnecessary page reload
      this.$router.push({
        name: Routes.CmsDynamicPage,
        params: {
          webrootPath: decodeURIComponent(this.model.target.replace('/page/', '')),
        },
      });
      event.preventDefault();
    }
  }
}
